// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { calendarClock16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-calendar-clock': IconCalendarClock;
    }
}

/**
 * The icon component for the 'calendarClock' icon
 */
export class IconCalendarClock extends IconSvg {
    public constructor() {
        super(calendarClock16X16);
    }
}

registerIconSvg('icon-calendar-clock', IconCalendarClock);
export const iconCalendarClockTag = 'nimble-icon-calendar-clock';
